import { Button, Modal } from 'antd';
import React, { useState } from 'react';

const ConfirmationModalApplicant = ({ open, close, onYesClick, id, value }) => {
    return (
        <Modal open={open}
            centered
            onCancel={close}

            footer={[
                <Button key="submit" onClick={() => {
                    localStorage.setItem('applicanttypeid', id);
                    localStorage.setItem('applicanttype', value);
                    localStorage.removeItem('applicant_details');
                    localStorage.removeItem('applicant_documents');
                    localStorage.removeItem('applicant_employement_details');
                    onYesClick();
                    close();
                }} type="primary">
                    Yes
                </Button>,
                <Button key="back" onClick={close}>
                    No
                </Button>,
            ]} title="Confirmation">
            <p>If you switch Applicant type, if you have any existing applicant and employemnt Data it will be cleared. Do you wish to continue? </p>
        </Modal>
    );
};

export default ConfirmationModalApplicant;